// ----------------------------------------------------------------------------
// Component: Newsletter
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/newsletter-form/newsletter-form';

// Styles
import './_newsletter.scss';